import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@els/els-react--button';

function ForgotPasswordDialogFooter({ result, submit, close, isLoading }) {
  if (!result) {
    return (
      <div className="forgot-password-dialog__footer">
        <Button
          type="primary"
          data-e2e="forgot-password-continue"
          expanded
          className="e2e-forgot-password-continue"
          disabled={isLoading}
          onClick={submit}>
          Send me a recovery email
        </Button>
      </div>
    );
  }

  return (
    <div className="forgot-password-dialog__footer">
      <Button type="primary" data-e2e="forgot-password-close" expanded className="e2e-forgot-password-close" onClick={close}>
        Close
      </Button>
    </div>
  );
}

ForgotPasswordDialogFooter.propTypes = {
  result: PropTypes.string,
  submit: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

export default ForgotPasswordDialogFooter;
